import dayjs from 'dayjs';

export function statsJsonToCsv(
  jsonStats,
  start,
  end,
  isSuperAdmin = false,
  idMapping = {},
) {
  if (!jsonStats) return '';
  const headers = ['section', 'category', 'metric', 'value', 'trend'];

  const isMetric = (v) => v?.value !== undefined;
  let flattenedStats = [];

  for (const [section, sectionData = {}] of Object.entries(jsonStats)) {
    for (const [catKey, catValue = {}] of Object.entries(sectionData)) {
      // Case 1: Flat metric (e.g., (users -> total_users))
      if (isMetric(catValue)) {
        flattenedStats.push({
          section,
          category: 'all',
          metric: catKey, // e.g. total_users
          value: catValue.value,
          trend: catValue.trend ?? null,
        });
        continue;
      }

      // Case 2: Category with single-nested metrics (e.g., (bookings -> all) -> total_bookings)
      if (isMetric(Object.values(catValue)?.[0])) {
        for (const [metricKey, data] of Object.entries(catValue)) {
          flattenedStats.push({
            section,
            category: catKey, // all
            metric: metricKey, //  e.g. total_bookings
            value: data?.value ?? null,
            trend: data?.trend ?? null,
          });
        }
        continue;
      }

      // Case 3: Category with doubly-nested metrics (e.g., (bookings -> by_cat_id) -> id_1 -> total_bookings)
      for (const [catId, metrics = {}] of Object.entries(catValue)) {
        for (const [metricKey, data] of Object.entries(metrics)) {
          flattenedStats.push({
            section,
            category: idMapping?.[catId] || catId, // Lookup Category Name from ID
            metric: metricKey, // e.g. total_bookings
            value: data?.value ?? null,
            trend: data?.trend ?? null,
          });
        }
      }
    }
  }

  if (!isSuperAdmin) {
    flattenedStats = flattenedStats.filter(
      ({ section }) => !['advertisement', 'platform_users'].includes(section),
    );
  }

  const rows = flattenedStats.map((row) =>
    headers
      .map((field) => {
        const val = row[field] ?? '';
        const escaped = String(val).replace(/"/g, '""');
        return `"${escaped}"`;
      })
      .join(','),
  );

  return [
    'start_date,' + start,
    'end_date,' + end,
    '',
    headers.join(','),
    ...rows,
  ];
}

export function downloadCsv(filename, csvContent) {
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);

  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

export function getStartDateForFilter(val) {
  if (val === 'yesterday') {
    return dayjs().subtract(1, 'day');
  } else if (val === 'week') {
    return dayjs().subtract(7, 'day');
  } else if (val === 'month') {
    // Month-to-date
    return dayjs().startOf('month');
  } else if (val === 'last_month') {
    return dayjs().subtract(30, 'day');
  } else if (val === 'all') {
    return dayjs(new Date(2020, 1, 1));
  }
  return dayjs();
}